// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getGoogleProfileRequestToJson, getGoogleProfileResponseFromJson, getLinkedinProfileRequestToJson, getLinkedinProfileResponseFromJson, getMicrosoftProfileRequestToJson, getMicrosoftProfileResponseFromJson, getSelfSignUpStatusRequestToJson, getSelfSignUpStatusResponseFromJson, isEmailDisposableRequestToJson, isEmailDisposableResponseFromJson, isEmailInUseRequestToJson, isEmailInUseResponseFromJson, loginRequestToJson, loginResponseFromJson, selfSignUpExistingAccountGroupRequestToJson, selfSignUpRequestToJson, selfSignUpWithGoogleRequestToJson, selfSignUpWithLinkedRequestToJson, signUpAgentRequestToJson, signUpRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function selfSignUp(request) {
    await fetchRpc('partner.v1.PartnerSignup/SelfSignUp', selfSignUpRequestToJson(request));
}
export function selfSignUp$(request, options) {
    return defer(() => selfSignUpWithTransport$(getGlobalTransport(), request, options));
}
export function selfSignUpWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerSignup/SelfSignUp', selfSignUpRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function selfSignUpWithGoogle(request) {
    await fetchRpc('partner.v1.PartnerSignup/SelfSignUpWithGoogle', selfSignUpWithGoogleRequestToJson(request));
}
export function selfSignUpWithGoogle$(request, options) {
    return defer(() => selfSignUpWithGoogleWithTransport$(getGlobalTransport(), request, options));
}
export function selfSignUpWithGoogleWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerSignup/SelfSignUpWithGoogle', selfSignUpWithGoogleRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function selfSignUpWithLinkedIn(request) {
    await fetchRpc('partner.v1.PartnerSignup/SelfSignUpWithLinkedIn', selfSignUpWithLinkedRequestToJson(request));
}
export function selfSignUpWithLinkedIn$(request, options) {
    return defer(() => selfSignUpWithLinkedInWithTransport$(getGlobalTransport(), request, options));
}
export function selfSignUpWithLinkedInWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerSignup/SelfSignUpWithLinkedIn', selfSignUpWithLinkedRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function selfSignUpExistingAccountGroup(request) {
    await fetchRpc('partner.v1.PartnerSignup/SelfSignUpExistingAccountGroup', selfSignUpExistingAccountGroupRequestToJson(request));
}
export function selfSignUpExistingAccountGroup$(request, options) {
    return defer(() => selfSignUpExistingAccountGroupWithTransport$(getGlobalTransport(), request, options));
}
export function selfSignUpExistingAccountGroupWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerSignup/SelfSignUpExistingAccountGroup', selfSignUpExistingAccountGroupRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function isEmailInUse(request) {
    const raw = await fetchRpc('partner.v1.PartnerSignup/IsEmailInUse', isEmailInUseRequestToJson(request));
    return isEmailInUseResponseFromJson(raw);
}
export function isEmailInUse$(request, options) {
    return defer(() => isEmailInUseWithTransport$(getGlobalTransport(), request, options));
}
export function isEmailInUseWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerSignup/IsEmailInUse', isEmailInUseRequestToJson(request), options)
        .pipe(map(resp => isEmailInUseResponseFromJson(resp)));
}
export async function isEmailDisposable(request) {
    const raw = await fetchRpc('partner.v1.PartnerSignup/IsEmailDisposable', isEmailDisposableRequestToJson(request));
    return isEmailDisposableResponseFromJson(raw);
}
export function isEmailDisposable$(request, options) {
    return defer(() => isEmailDisposableWithTransport$(getGlobalTransport(), request, options));
}
export function isEmailDisposableWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerSignup/IsEmailDisposable', isEmailDisposableRequestToJson(request), options)
        .pipe(map(resp => isEmailDisposableResponseFromJson(resp)));
}
export async function getSelfSignUpStatus(request) {
    const raw = await fetchRpc('partner.v1.PartnerSignup/GetSelfSignUpStatus', getSelfSignUpStatusRequestToJson(request));
    return getSelfSignUpStatusResponseFromJson(raw);
}
export function getSelfSignUpStatus$(request, options) {
    return defer(() => getSelfSignUpStatusWithTransport$(getGlobalTransport(), request, options));
}
export function getSelfSignUpStatusWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerSignup/GetSelfSignUpStatus', getSelfSignUpStatusRequestToJson(request), options)
        .pipe(map(resp => getSelfSignUpStatusResponseFromJson(resp)));
}
export async function login(request) {
    const raw = await fetchRpc('partner.v1.PartnerSignup/Login', loginRequestToJson(request));
    return loginResponseFromJson(raw);
}
export function login$(request, options) {
    return defer(() => loginWithTransport$(getGlobalTransport(), request, options));
}
export function loginWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerSignup/Login', loginRequestToJson(request), options)
        .pipe(map(resp => loginResponseFromJson(resp)));
}
export async function signUp(request) {
    await fetchRpc('partner.v1.PartnerSignup/SignUp', signUpRequestToJson(request));
}
export function signUp$(request, options) {
    return defer(() => signUpWithTransport$(getGlobalTransport(), request, options));
}
export function signUpWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerSignup/SignUp', signUpRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getGoogleProfile(request) {
    const raw = await fetchRpc('partner.v1.PartnerSignup/GetGoogleProfile', getGoogleProfileRequestToJson(request));
    return getGoogleProfileResponseFromJson(raw);
}
export function getGoogleProfile$(request, options) {
    return defer(() => getGoogleProfileWithTransport$(getGlobalTransport(), request, options));
}
export function getGoogleProfileWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerSignup/GetGoogleProfile', getGoogleProfileRequestToJson(request), options)
        .pipe(map(resp => getGoogleProfileResponseFromJson(resp)));
}
export async function getLinkedInProfile(request) {
    const raw = await fetchRpc('partner.v1.PartnerSignup/GetLinkedInProfile', getLinkedinProfileRequestToJson(request));
    return getLinkedinProfileResponseFromJson(raw);
}
export function getLinkedInProfile$(request, options) {
    return defer(() => getLinkedInProfileWithTransport$(getGlobalTransport(), request, options));
}
export function getLinkedInProfileWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerSignup/GetLinkedInProfile', getLinkedinProfileRequestToJson(request), options)
        .pipe(map(resp => getLinkedinProfileResponseFromJson(resp)));
}
export async function getMicrosoftProfile(request) {
    const raw = await fetchRpc('partner.v1.PartnerSignup/GetMicrosoftProfile', getMicrosoftProfileRequestToJson(request));
    return getMicrosoftProfileResponseFromJson(raw);
}
export function getMicrosoftProfile$(request, options) {
    return defer(() => getMicrosoftProfileWithTransport$(getGlobalTransport(), request, options));
}
export function getMicrosoftProfileWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerSignup/GetMicrosoftProfile', getMicrosoftProfileRequestToJson(request), options)
        .pipe(map(resp => getMicrosoftProfileResponseFromJson(resp)));
}
export async function signUpAgent(request) {
    await fetchRpc('partner.v1.PartnerSignup/SignUpAgent', signUpAgentRequestToJson(request));
}
export function signUpAgent$(request, options) {
    return defer(() => signUpAgentWithTransport$(getGlobalTransport(), request, options));
}
export function signUpAgentWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerSignup/SignUpAgent', signUpAgentRequestToJson(request), options)
        .pipe(map(() => undefined));
}
